import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Image } from "antd";
import moment from "moment";

import Swal from "sweetalert2";

import inquiryApi from "../../../apis/Inquiry.api";
import { setLoading } from "../../../redux/store/common/commonDuck";

const InquiryManageEachQuestion = ({ inquiryValue, inquiryImageList }) => {
	const history = useHistory();
	const dispatch = useDispatch();
	const user = useSelector((state) => state.auth.user);
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	/**
	 * 질문/답변 모두 삭제
	 * @returns {Promise<void>}
	 */
	const deleteInquiryAll = async () => {
		Swal.fire({
			customClass: "alert-custom",
			text: "해당 글을 삭제하시겠습니까?",
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				setIsLoading(true);
				const param = {
					inquiryId: inquiryValue?.id,
					influencerId: user?.id,
					userId: user?.id,
				};
				const res = await inquiryApi.adminDeleteInquiryAll(param);
				if (res.code === 200) {
					Swal.fire({
						customClass: "alert-custom",
						text: "성공적으로 삭제되었습니다!",
						confirmButtonText: "확인",
					}).then((res) => {
						history.replace(`/inquiry_manage`);
						setIsLoading(false);
					});
				} else {
					Swal.fire({
						customClass: "alert-custom",
						text: "오류가 발생했습니다.\n잠시 후 다시 시도해주세요.",
						confirmButtonText: "확인",
					}).then((res) => {
						console.log("delete-inquiry-list-error");
						setIsLoading(false);
					});
				}
			}
		});
	};

	return (
		<div className={`inquiry-manage-each-component`}>
			<div className={`inquiry-manage-title-div`}>
				<p>질문내용</p>
				<Button onClick={deleteInquiryAll} loading={isLoading}>
					삭제
				</Button>
			</div>
			<div className={`inquiry-manage-question`}>
				<div className={`inquiry-manage-question-title`}>
					<p className={`${inquiryValue?.is_answer ? "success" : ""} status`}>
						{inquiryValue?.is_answer ? "답변완료" : "답변예정"}
					</p>
					<p className={`title`}>
						{inquiryValue?.is_secret ? (
							<>
								<img
									src={`/assets/images/channel/secret-black.png`}
									alt={`비밀댓글`}
									style={{
										width: "0.9em",
										height: "auto",
										marginRight: "3px",
									}}
								/>
								{inquiryValue?.title}
							</>
						) : (
							<>{inquiryValue?.title}</>
						)}
					</p>
					<p
						className={`gray`}
						style={{
							marginLeft: "auto",
						}}
					>
						{inquiryValue?.created_by_name}
					</p>
				</div>
				<div className={`inquiry-manage-question-body`}>
					<p className={`content`}>{inquiryValue?.content}</p>
					{!!inquiryImageList?.length && (
						<div className={`inquiry-manage-each-image-group`}>
							<Image.PreviewGroup>
								{inquiryImageList?.map((src, idx) => (
									<Image
										preview={{
											mask: <></>,
										}}
										src={src}
										alt={`문의 이미지 ${idx}`}
										key={`inquiry-each-image-${idx}`}
									/>
								))}
							</Image.PreviewGroup>
						</div>
					)}
					<p
						className={`gray`}
						style={{
							marginTop: "3em",
						}}
					>
						{moment(inquiryValue?.created_at).format("YYYY.MM.DD")}
					</p>
				</div>
			</div>
		</div>
	);
};
export default InquiryManageEachQuestion;
